<div class="flex-col center-start wrapper">
  <div class="flex-row end-center save-block">
    <ui-button
      [loading]="selectIsSaving$ | ngrxPush"
      [disabled]="!(selectIsValid$ | ngrxPush)"
      icon="save"
      text="Save"
      (clickAction)="save()"
    >
    </ui-button>
  </div>
  <div class="flex-col space-between-start main-settings mw-m p-30">
    <h1>Settings</h1>
    <div class="flex-row flex-fill tab-containers">
      <div class="view-tab" routerLink="profile" routerLinkActive="active">Profile</div>
      <div class="view-tab" routerLink="organization" routerLinkActive="active">Organization</div>
      <div class="view-tab" routerLink="password" routerLinkActive="active">Password</div>
    </div>
    <div style="height: calc(100vh - 290px); width: 100%; padding: 20px 0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
